var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("cursor-pointer px-4 py-1 " + (_vm.color === 'primary'
        ? _vm.toggled
          ? 'bg-pink-600 active:bg-pink-600'
          : 'bg-pink-500 active:bg-pink-700'
        : _vm.toggled
        ? 'bg-gray-700 active:bg-gray-700 text-white'
        : 'bg-gray-500 active:bg-gray-700')),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }